import React from 'react';
import { Container } from 'components/common';
import contact from 'assets/illustrations/undraw_message_sent_1030.svg';
import { Wrapper, Details, Thumbnail } from './styles';
import ContactForm from './ContactForm';

export const Contact = () => (
  <Wrapper as={Container} id="contact">
    <Details>
      <h1>Questions? Reach out!</h1>
      <ContactForm />
    </Details>
    <Thumbnail>
      <img src={contact} alt="Send message illustration" />
    </Thumbnail>
  </Wrapper>
);
